export const CATALOG_PAGE_SIZE = 18;

export function catalogPage(value: string | null): number {
  const page = Number(value);
  return Number.isFinite(page) && page >= 1 ? Math.min(10000, Math.floor(page)) : 1;
}
export function catalogSearch(params: URLSearchParams): URLSearchParams {
  const search = new URLSearchParams(params);
  if (search.has('page')) search.set('page', String(catalogPage(search.get('page'))));
  search.set('page_size', String(CATALOG_PAGE_SIZE));
  return search;
}
